import { render, staticRenderFns } from "./Nedetel.vue?vue&type=template&id=b9b50104"
import script from "./Nedetel.vue?vue&type=script&lang=js"
export * from "./Nedetel.vue?vue&type=script&lang=js"
import style0 from "./Nedetel.vue?vue&type=style&index=0&id=b9b50104&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports